import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel, { orderByOptions } from "../../../ViewModels/CallTableViewModel";
import OrderByDialog from "./OrderByDialog";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IOrderByProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function OrderBy({ callTableViewModel, setCallTableViewModel }: IOrderByProps) {
    const [open, setOpen] = useState(false);

    const label = orderByOptions.find(o => o.value === callTableViewModel.filters.orderBy)?.label ?? orderByOptions[0].label;

    const text =
        <Typography variant="body1">
            {
                "Order By - " + label
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <OrderByDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}